const swapMap = (mapStructure: Map<string, string>): Map<string, string> => {
  const mapToArray = Array.from(mapStructure);
  return new Map(mapToArray.map(
    ([key, value]): readonly [string, string] => [value, key]
  ));
}

export default swapMap;
